if (!customElements.get('af-cooling-popover')) {
  customElements.define('af-cooling-popover', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger = this.querySelector('.af-cooling-popover__trigger');
      this.panel = this.querySelector('[popover]');
      this.panel.addEventListener('toggle', (event) => {
        this.trigger.setAttribute('aria-expanded', String(event.newState === 'open'));
        if (event.newState === 'open') this.position();
      }, options);
      window.addEventListener('resize', () => this.position(), options);
      window.addEventListener('scroll', () => this.position(), { ...options, capture: true, passive: true });
    }

    position() {
      if (!this.panel.matches(':popover-open')) return;
      const anchor = this.trigger.getBoundingClientRect();
      const box = this.panel.getBoundingClientRect();
      const gap = 10;
      const padding = 12;
      const left = Math.max(padding, Math.min(anchor.left + anchor.width / 2 - box.width / 2, window.innerWidth - box.width - padding));
      const below = anchor.bottom + gap;
      const top = below + box.height <= window.innerHeight - padding
        ? below
        : Math.max(padding, Math.min(anchor.top - box.height - gap, window.innerHeight - box.height - padding));
      this.panel.style.left = `${left}px`;
      this.panel.style.top = `${top}px`;
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
